import styles from './TurnIndicator.module.css';

export interface TurnIndicatorProps {
  nickname: string;
  avatar: string;
  isMyTurn: boolean;
}

function getAvatarSrc(name: string): string {
  const file = name.toLowerCase().replace(/\s+/g, '-');
  return `/avatars/${file}.svg`;
}

export function TurnIndicator({ nickname, avatar, isMyTurn }: TurnIndicatorProps) {
  return (
    <div
      className={`${styles.container} ${isMyTurn ? styles.myTurn : ''}`}
      aria-live="polite"
      aria-atomic="true"
    >
      <img
        src={getAvatarSrc(avatar)}
        alt={`${nickname}'s avatar`}
        className={styles.avatar}
      />
      <span className={styles.text}>{nickname}&apos;s Turn</span>
    </div>
  );
}
